module.exports = __webpack_public_path__ + "static/media/processing.eb485e57.png";